import { render, staticRenderFns } from "./roster_form.vue?vue&type=template&id=3c6f6b4c&"
import script from "./roster_form.vue?vue&type=script&lang=js&"
export * from "./roster_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports